module.exports = __webpack_public_path__ + "static/img/materialBanner.4019dbe7.png";